import React from 'react';
import { Placeholder } from 'react-bootstrap';

/**
 * A figure that is never a false 0: a placeholder while it loads, a dash with
 * a spoken reason when the read failed, the value otherwise.
 */
function StatValue({ value, loading = false, failed = false }) {
    if (loading) {
        return (
            <Placeholder as="span" animation="glow">
                <Placeholder xs={3} />
                <span className="visually-hidden">Loading</span>
            </Placeholder>
        );
    }
    if (failed) {
        return (
            <>
                <span aria-hidden>&ndash;</span>
                <span className="visually-hidden">Not available</span>
            </>
        );
    }
    return <>{value}</>;
}

export default StatValue;
